import { UbudStorageModule } from '@ubud/storage';
import { NgModule } from '@angular/core';
import { InstitutionTypeService } from '@lemsar/common/domains/services/institution-type.service';
import { MinistryService } from '@lemsar/common/domains/services/ministry.service';
import { AddressingService } from '@lemsar/common/domains/services/addressing.service';
import { StandardService } from '@lemsar/common/domains/services/standard.service';
import { SubVocationalService } from '@lemsar/common/domains/services/sub-vocational.service';
import { FundService } from '@lemsar/common/domains/services/fund.service';
import { BuildingTypeService } from '@lemsar/common/domains/services/building-type.service';
import { ProvinceService } from '@lemsar/common/domains/services/province.service';
import { GroupVocationalService } from '@lemsar/common/domains/services/group-vocational.service';
import { SectorService } from '@lemsar/common/domains/services/sector.service';
import { VocationalService } from '@lemsar/common/domains/services/vocational.service';
import { EquipmentCategoryService } from '@lemsar/common/domains/services/equipment-category.service';
import { CityService } from '@lemsar/common/domains/services/city.service';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    16/06/2018
 */
@NgModule({
    imports: [UbudStorageModule],
    providers: [
        InstitutionTypeService,
        MinistryService,
        AddressingService,
        StandardService,
        SubVocationalService,
        FundService,
        BuildingTypeService,
        ProvinceService,
        GroupVocationalService,
        SectorService,
        VocationalService,
        EquipmentCategoryService,
        CityService,
    ],
})
export class LemsarCommonDomainModule {}



// WEBPACK FOOTER //
// ./src/lemsar/common/domains/module.ts